import React from 'react'
import { Slot } from 'radix-ui'

import { useModals } from '@/shared/lib/modal-manager'

export const ReassignPricingCampaign = ({
	pricingCampaignsIds,
	onDone,
	children,
}: {
	pricingCampaignsIds: string[]
	onDone?: () => void
	children: React.ReactNode
}) => {
	const { showModal } = useModals()
	const handleReassign = () => {
		showModal('MOVE_PRICING_CANPAIGNS', {
			selected: pricingCampaignsIds,
			resetSelectedItems: onDone,
		})
	}

	return <Slot.Root onClick={handleReassign}>{children}</Slot.Root>
}
